/**
 * PM Platform -- Contact Center movil: apertura/cierre con layout
 * instantaneo + fade corto.
 *
 * Dos rondas anteriores animaron la ALTURA de .pm-mobile-contact__content
 * (primero junto con opacity en el mismo nodo, despues en dos nodos
 * separados con delays coordinados). Ambas seguian mostrando en Shopify
 * un revelado vertical progresivo -- porque, mientras exista una
 * interpolacion real de height + overflow:hidden, el contenido SIEMPRE
 * se revela fisicamente de arriba hacia abajo, sin importar en que
 * elemento viva la opacity. La causa raiz no era el timing ni la capa:
 * era la propia animacion de altura.
 *
 * Esta ronda la elimina por completo. <details open> ya NO se anima:
 * el navegador le asigna su altura final de forma nativa e instantanea
 * en el mismo tick en que se activa "open". La UNICA animacion visual
 * real es la opacity de .pm-mobile-contact__content-inner (fade corto),
 * agregada/quitada sobre un layout que ya esta completo -- por lo tanto
 * no puede existir clipping vertical progresivo: el contenido nunca
 * vive dentro de una caja cuya altura este interpolandose.
 *
 * Apertura: el inner se fija a opacity:0 (o su valor interpolado real,
 * ver mas abajo) ANTES de activar "open", para que no exista un frame
 * con el layout ya abierto y el contenido en opacidad plena antes de
 * que la animacion tome control. Cierre: <details> permanece "open"
 * durante todo el fade -- solo se pone en false cuando el contenido ya
 * es invisible, para que el colapso del layout ocurra sin nada visible
 * dentro.
 *
 * <details>/<summary> nativo sigue siendo progressive enhancement real:
 * si este script no carga, el toggle nativo instantaneo de <details>
 * sigue funcionando -- ninguna regla CSS deja el inner en opacity:0 de
 * forma permanente, solo un estilo inline temporal que este script
 * gestiona y limpia.
 *
 * Alcance exclusivo: instancias de .pm-mobile-contact. Sin
 * MutationObserver/ResizeObserver/setInterval/listeners de scroll o
 * resize, sin requestAnimationFrame (ya no hay ninguna geometria que
 * medir antes de animar).
 */
(function () {
  "use strict";

  var OPEN_FADE_MS = 120;
  var CLOSE_FADE_MS = 80;
  var EASING = "cubic-bezier(0.2, 0.8, 0.2, 1)";

  var initialized = new WeakSet();

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initInstance(details) {
    if (initialized.has(details)) return;

    var summary = details.querySelector(":scope > summary");
    var content = details.querySelector(":scope > .pm-mobile-contact__content");
    var inner = content && content.querySelector(":scope > .pm-mobile-contact__content-inner");
    // Las tres dependencias estructurales se validan ANTES de marcar la
    // instancia como inicializada -- si alguna falta, la funcion vuelve
    // sin marcar nada, para que un shopify:section:load posterior (con
    // el DOM ya completo) pueda reintentar en vez de quedar bloqueada
    // por el WeakSet.
    if (!summary || !content || !inner) return;

    initialized.add(details);

    // isOpen: unica fuente de verdad sobre "hacia donde vamos" -- se
    // invierte en cada click sin importar en que punto de un fade en
    // curso estemos. details.open, en cambio, permanece true durante
    // TODO el cierre (se fija a false solo al terminar el fade-out) y
    // por eso no sirve por si solo para decidir direccion a mitad de
    // camino.
    var isOpen = details.open;
    var opacityAnimation = null;
    // generation: invalida callbacks "finish" de una transicion vieja
    // si el usuario ya inicio una nueva antes de que terminara (rapid
    // click). cancel() ya es sincronico -- una animacion cancelada
    // nunca llega a disparar su propio "finish" -- asi que esto es un
    // resguardo defensivo adicional, no la unica proteccion real.
    var generation = 0;

    // Mientras hay una animacion en vuelo, el valor computado ya
    // refleja la opacity real interpolada en ese instante (WAAPI la
    // aplica por encima de la cascada). En reposo, el valor es
    // determinista segun el estado real de <details>.
    function currentOpacity() {
      if (opacityAnimation) {
        var parsed = parseFloat(getComputedStyle(inner).opacity);
        return isNaN(parsed) ? (isOpen ? 1 : 0) : parsed;
      }
      return details.open ? 1 : 0;
    }

    function cleanup() {
      inner.style.opacity = "";
    }

    function runTransition(targetOpen) {
      // Estado visual REAL en este instante -- se lee ANTES de cancelar
      // nada, para que la nueva transicion parta visualmente de donde
      // el usuario la vio por ultima vez, sin saltos.
      var fromOpacity = currentOpacity();

      if (opacityAnimation) {
        opacityAnimation.cancel();
        opacityAnimation = null;
      }
      generation++;
      var myGeneration = generation;

      if (prefersReducedMotion()) {
        cleanup();
        details.open = targetOpen;
        return;
      }

      if (targetOpen) {
        // Anti-flash: el inner queda fijado a su opacity real ANTES de
        // activar "open" -- nunca debe existir un frame con
        // details.open=true y el contenido en opacidad plena antes de
        // que la animacion tome control. Sin requestAnimationFrame: ya
        // no hay ninguna geometria que medir (no se anima height), asi
        // que WAAPI puede arrancar en el mismo tick.
        inner.style.opacity = String(fromOpacity);
        details.open = true;

        opacityAnimation = inner.animate(
          [{ opacity: fromOpacity }, { opacity: 1 }],
          { duration: OPEN_FADE_MS, easing: EASING, fill: "forwards" }
        );

        opacityAnimation.addEventListener("finish", function () {
          if (myGeneration !== generation) return;
          opacityAnimation = null;
          cleanup();
        });
        opacityAnimation.addEventListener("cancel", function () {
          opacityAnimation = null;
        });
      } else {
        // details permanece "open" durante todo el fade -- solo se fija
        // a false cuando el contenido ya es invisible (ver "finish"),
        // para que el layout colapse sin nada visible dentro.
        opacityAnimation = inner.animate(
          [{ opacity: fromOpacity }, { opacity: 0 }],
          { duration: CLOSE_FADE_MS, easing: EASING, fill: "forwards" }
        );

        opacityAnimation.addEventListener("finish", function () {
          if (myGeneration !== generation) return;
          opacityAnimation = null;
          cleanup();
          details.open = false;
        });
        opacityAnimation.addEventListener("cancel", function () {
          opacityAnimation = null;
        });
      }
    }

    summary.addEventListener("click", function (event) {
      // Reemplaza el toggle nativo instantaneo por el flujo de fade --
      // <summary> sigue respondiendo a click real y a activacion por
      // teclado (Enter/Espacio), que el navegador sintetiza como el
      // mismo evento "click" sobre el propio <summary>, asi que este
      // unico listener cubre ambos casos sin necesitar un manejador de
      // teclado aparte.
      event.preventDefault();

      isOpen = !isOpen;
      runTransition(isOpen);
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var instances = root.querySelectorAll(".pm-mobile-contact");
    for (var i = 0; i < instances.length; i++) {
      initInstance(instances[i]);
    }
  }

  init();

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
